import React, { useState, Fragment, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import API from '../../services/API';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Collapse } from 'reactstrap';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { Tag, Dropdown, Menu } from 'antd';


const ClassesPage = () => {
    const [classes, setClasses] = useState([]);
    const [teachers, setTeachers] = useState([]); // List of all teachers
    const [selectedClass, setSelectedClass] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [updatedClassName, setUpdatedClassName] = useState('');
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedTeachers, setSelectedTeachers] = useState([]); // Selected teachers for the class
    const [newClassName, setNewClassName] = useState('');
    const [selectedForm, setSelectedForm] = useState(null); // Selected form for the new class
    const [selectedSession, setSelectedSession] = useState(null);
    const [editSession, setEditSession] = useState(null);
    const [newTingkatan, setNewTingkatan] = useState('');
    const [newClassMoeis, setNewClassMoeis] = useState('');
    const [editTingkatan, setEditTingkatan] = useState('');
    const [editClassMoeis, setEditClassMoeis] = useState('');
    const [formFilter, setFormFilter] = useState(null);
    const [uniqueForms, setUniqueForms] = useState([]);
    const [incompleteClasses, setIncompleteClasses] = useState([]);
    const [currentIncompleteIndex, setCurrentIncompleteIndex] = useState(0);
    const [infoOpen, setInfoOpen] = useState(false);
    // Rotate every 3 seconds
    useEffect(() => {
        if (incompleteClasses.length > 0) {
            const interval = setInterval(() => {
                setCurrentIncompleteIndex(prev =>
                    (prev + 1) % incompleteClasses.length
                );
            }, 3000); // change every 3s
            return () => clearInterval(interval);
        }
    }, [incompleteClasses]);
    const sessionOptions = [
        { value: 0, label: "Morning" },
        { value: 1, label: "Afternoon" },
    ];

    const navigate = useNavigate();
    const forms = [
         {
            label: 'Others(Teacher/Staff etc)',
            value: '0',  // or use '7' if your backend expects a number
        },
        {
            label: 'Pra-sekolah',
            value: '9',  // or use '7' if your backend expects a number
        },
        {
            label: 'Khas',
            value: '7',  // or use '7' if your backend expects a number
        },
        {
            label: 'Peralihan',
            value: '8',  // or use '7' if your backend expects a number
        },
        ...Array.from({ length: 6 }, (_, index) => ({
            label: `Form/Standard/Tadika ${index + 1}`,
            value: `${index + 1}`,
        })),

    ];
    // Filter classes by form
    const filteredClasses = formFilter
        ? classes.filter(
            (c) => String(c.tingkatan_moeis).toUpperCase().trim() === formFilter
        )
        : classes;

    const [columns] = useState([
        {
            name: "Class Info",
            grow: 1,
            selector: row => row.class_name,
            sortable: true,
            cell: (row) => (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    minWidth: 120,   // 🔧 reduced from 160
                    maxWidth: 200,   // 🔧 prevent being too wide
                    padding: "6px 0",
                    width: "100%",
                    whiteSpace: "normal", // ✅ allow wrapping
                    wordBreak: "break-word" // ✅ prevent overlap
                }}>
                    {/* Class Name */}
                    <span style={{
                        fontWeight: 700,
                        fontSize: 16,
                        color: "#1a1a1a"
                    }}>
                        {row.class_name}
                    </span>

                    {/* MOEIS Class Format */}
                    {row.class_moeis_format && (
                        <span style={{
                            fontSize: 13,
                            color: "#666",
                            marginTop: 2,
                            fontStyle: "italic",
                        }}>
                            ({row.class_moeis_format})
                        </span>
                    )}

                    {/* Session Badge */}
                    <span style={{
                        marginTop: 6,
                        padding: "4px 12px",
                        borderRadius: "20px",
                        background: row.session == 0 ? "#d1f5d3" : "#ffe5d1",
                        color: row.session == 0 ? "#2e7d32" : "#d35400",
                        fontSize: 12,
                        fontWeight: "600",
                    }}>
                        {row.session == 0 ? "Morning Session" : "Afternoon Session"}
                    </span>
                </div>
            )
        },
        {
            name: "Teachers",
            grow: 2,
            selector: (row) => {
                const maxVisible = 5; // show only first 5 teachers
                const visibleTeachers = row.teachers.slice(0, maxVisible);
                const hiddenTeachers = row.teachers.slice(maxVisible);

                return (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                        {/* Show first few teachers */}
                        {visibleTeachers.map((teacher, index) => (
                            <Tag
                                key={teacher.teacher_uuid || index}
                                color="blue"
                                style={{ whiteSpace: "nowrap" }}
                            >
                                {teacher.teacher_name}
                            </Tag>
                        ))}

                        {/* If more, show dropdown */}
                        {hiddenTeachers.length > 0 && (
                            <Dropdown
                                overlay={
                                    <Menu>
                                        {hiddenTeachers.map((teacher, index) => (
                                            <Menu.Item key={teacher.teacher_uuid || index}>
                                                {teacher.teacher_name}
                                            </Menu.Item>
                                        ))}
                                    </Menu>
                                }
                                placement="bottomLeft"
                            >
                                <Tag color="purple" style={{ cursor: "pointer" }}>
                                    +{hiddenTeachers.length} more
                                </Tag>
                            </Dropdown>
                        )}
                    </div>
                );
            },
        },
        {
            name: "Actions",
            cell: (row) => (
                <div
                    className="actions-container"
                >
                    <button
                        className="m-2 btn btn-outline-dark btn-sm"
                        onClick={() => navigate(`/class-details/${row.class_id}`)}
                    >
                        View
                    </button>
                    <button
                        className="m-2 btn btn-outline-primary btn-sm"
                        onClick={() => openEditModal(row)}
                    >
                        Edit
                    </button>
                    <button
                        className="m-2 btn btn-outline-danger btn-sm"
                        onClick={() => openDeleteModal(row)}
                    >
                        Delete
                    </button>
                </div>
            ),
            center: true,
        }
    ]);

    // Fetch classes from the API
    const fetchClasses = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        API.get('/portal/getClasses', { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    const fetchedClasses = response.data.data;
                    setClasses(fetchedClasses);
                    // 👇 Extract unique tingkatan_moeis values
                    const formsFromAPI = Array.from(
                        new Set(fetchedClasses.map(c => c.tingkatan_moeis?.toUpperCase().trim()))
                    ).filter(Boolean);
                    const missing = fetchedClasses.filter(
                        c => !c.tingkatan_moeis || !c.class_moeis_format
                    );
                    setIncompleteClasses(missing);

                    setUniqueForms(formsFromAPI);
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error fetching classes", { autoClose: 5000 });
            });
    };

    // Fetch all teachers from the API
    const fetchTeachers = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        API.get('/portal/getTeachers', { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {

                    const teacherOptions = response.data.data.map((teacher) => ({
                        label: teacher.full_name,
                        value: teacher.teacher_uuid,
                    }));

                    setTeachers(teacherOptions);
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error fetching teachers", { autoClose: 5000 });
            });
    };

    useEffect(() => {
        fetchClasses();
        fetchTeachers();
    }, []);

    // Open the modal for editing a class
    const openEditModal = (classData) => {
        setSelectedClass(classData);
        setUpdatedClassName(classData.class_name);
        setSelectedTeachers(classData.teachers.map((teacher) => ({
            label: teacher.teacher_name,
            value: teacher.teacher_uuid,
        })));
        // Set session
        const sessionOption = sessionOptions.find(opt => opt.value === classData.session);
        setEditSession(sessionOption || null);
        setEditTingkatan(classData.tingkatan_moeis || '');
        setEditClassMoeis(classData.class_moeis_format || '');
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setSelectedClass(null);
        setIsEditModalOpen(false);
    };
    const openAddModal = () => {
        setNewClassName('');
        setSelectedTeachers([]);
        setIsAddModalOpen(true);
    };

    const closeAddModal = () => {
        setIsAddModalOpen(false);
    };
    const openDeleteModal = (classData) => {
        setSelectedClass(classData);
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setSelectedClass(null);
        setIsDeleteModalOpen(false);
    };
    const handleAddClass = () => {
        if (!newClassName) {
            toast.error("Class name cannot be empty", { autoClose: 5000 });
            return;
        }
        if (selectedSession === null) {
            toast.error("Please select a session (morning/afternoon)", { autoClose: 5000 });
            return;
        }
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };
        API.post('/portal/addClass', {
            class_name: newClassName,
            form: selectedForm.value,
            session: selectedSession.value,
            tingkatan_moeis: newTingkatan || null,
            class_moeis: newClassMoeis || null,
        }, { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    toast.success("Class added successfully", { autoClose: 5000 });
                    closeAddModal();
                    fetchClasses();

                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error adding class", { autoClose: 5000 });
            });
    };
    const handleDeleteClass = () => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        API.post('/portal/deleteClass', {
            class_id: selectedClass.class_id,
        }, { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    toast.success("Class deleted successfully", { autoClose: 5000 });
                    closeDeleteModal();
                    fetchClasses();
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error deleting class", { autoClose: 5000 });
            });
    };
    const handleSaveChanges = () => {
        if (!updatedClassName) {
            toast.error("Class name cannot be empty", { autoClose: 5000 });
            return;
        }
        if (!editSession) {
            toast.error("Please select a session (morning/afternoon)", { autoClose: 5000 });
            return;
        }
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        // Map selected teachers to their UUIDs
        const teacherUUIDs = selectedTeachers.map((teacher) => teacher.value);
        // Send the updated list of teachers to the backend
        API.post('/portal/updateTeachersForClass', {
            class_id: selectedClass.class_id,
            class_name: updatedClassName,
            teacher_uuids: teacherUUIDs,
            session: editSession.value,
            tingkatan_moeis: editTingkatan || null,
            class_moeis: editClassMoeis || null,
        }, { headers })
            .then((response) => {
                if (response.data.response_code === 1000) {
                    toast.success("Class updated successfully", { autoClose: 5000 });
                    closeEditModal();
                    fetchClasses(); // Refresh the classes list
                } else {
                    toast.error(`${response.data.message}`, { autoClose: 5000 });
                }
            })
            .catch(() => {
                toast.error("Error updating class", { autoClose: 5000 });
            });
    };


    return (
        <Fragment>
            {/* Info Guide */}
            <div className="mb-4">
                {/* Toggle Button for Mobile */}
                <button
                    className="btn btn-sm btn-outline-secondary d-lg-none w-100"
                    onClick={() => setInfoOpen(!infoOpen)}
                >
                    {infoOpen ? "Sembunyi Panduan" : "Tunjuk Panduan"}
                </button>

                {/* Collapsible Content */}
                <Collapse isOpen={infoOpen} className="d-lg-block mt-3">
                    <div
                        className="p-4 border rounded bg-white shadow-sm"
                        style={{ fontSize: "15px", lineHeight: "1.6" }}
                    >
                        <h6 className="fw-bold mb-3 text-dark">Panduan</h6>
                        <ul className="mb-2 ps-3 text-secondary">
                            <li>
                                <strong>Tingkatan MOEIS</strong> – Mesti sama dengan rekod rasmi MOEIS.
                            </li>
                            <li>
                                <strong>Format Kelas MOEIS</strong> – Gunakan format yang tepat
                                (cth. <i>TINGKATAN 1 AMANAH</i>).
                            </li>
                            <li style={{ fontSize: "16px", lineHeight: "1.8" }}>
                                <span
                                    className="badge bg-danger me-2"
                                    style={{ fontSize: "15px", padding: "6px 12px" }}
                                >
                                    Belum Rekod Muka
                                </span>
                                Murid yang <strong>belum merekod wajah</strong> akan{" "}
                                <strong>secara automatik ditandakan sebagai Tidak Hadir ke dalam MOEIS</strong>{" "}
                                dengan sebab mengikut tetapan sekolah (cth. <i>Malas ke Sekolah</i>).
                            </li>
                        </ul>
                        <p className="mt-2 text-muted" style={{ fontSize: "14px", fontWeight: 500 }}>
                            <strong>Tip:</strong> Pastikan Tingkatan & Format Kelas diisi dengan betul
                            untuk elak ralat semakan MOEIS.
                        </p>
                    </div>
                </Collapse>
            </div>

            <div className="container-fluid">
                <div className="mb-3 d-flex flex-wrap gap-2">
                    {/* "All" pill */}
                    <button
                        className={`btn btn-sm ${formFilter === null ? "btn-dark" : "btn-outline-dark"}`}
                        onClick={() => setFormFilter(null)}
                    >
                        All
                    </button>

                    {/* Dynamic pills from API */}
                    {uniqueForms.map((form) => (
                        <button
                            key={form}
                            className={`btn btn-sm ${formFilter === form ? "btn-dark" : "btn-outline-dark"}`}
                            onClick={() => setFormFilter(form)}
                        >
                            {form}
                        </button>
                    ))}
                </div>
                {incompleteClasses.length > 0 && (
                    <div
                        className="d-flex flex-column"
                        role="alert"
                        style={{
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "15px",
                            padding: "16px 20px",
                            marginBottom: "20px",
                            backgroundColor: "#ffc107", // 🟡 Bootstrap warning yellow
                            color: "#212529",           // dark text for readability
                        }}
                    >
                        <div className="d-flex align-items-center justify-content-between">
                            <div>
                                <span
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "50%",
                                        background: "#fff",
                                        color: "#000", // yellow number
                                        fontWeight: "900",
                                        margin: "0 12px",
                                        fontSize: "28px",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    {incompleteClasses.length}
                                </span>

                                <strong>Action required:</strong>{" "}
                                {incompleteClasses.length > 1 ? "Classes are" : "Class is"} missing{" "}
                                <strong>MOEIS info</strong>.{" "}
                                <span style={{ fontWeight: "500" }}>
                                    Update now to ensure smooth MOEIS integration.
                                </span>
                            </div>

                            {/* Action button */}
                            <button
                                className="btn btn-dark btn-sm"
                                onClick={() => {
                                    const currentClass = incompleteClasses[currentIncompleteIndex];
                                    if (currentClass) {
                                        openEditModal(currentClass);
                                    }
                                }}
                            >
                                Fix Now
                            </button>
                        </div>
                    </div>

                )}


                <div className="row">
                    <div className="col-12">
                        <div className="card rounded-25">
                            <div className="card-header rounded-25 text-red">
                                <h5>Classes</h5>
                                <button
                                    className="btn btn-primary float-end"
                                    onClick={openAddModal}
                                >
                                    Add Class
                                </button>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <DataTable
                                        columns={columns}
                                        data={filteredClasses}
                                        striped={true}
                                        center={false}
                                        responsive
                                        persistTableHead

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selectedClass && (
                <Modal isOpen={isEditModalOpen} toggle={closeEditModal}>
                    <ModalHeader toggle={closeEditModal}>
                        Edit Class Details
                    </ModalHeader>
                    <ModalBody>
                        <div className="form-group">
                            <label>Class Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={updatedClassName}
                                onChange={(e) => setUpdatedClassName(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Assign Teachers</label>
                            {isEditModalOpen && (
                                <Select
                                    isMulti
                                    options={teachers}
                                    value={selectedTeachers}
                                    onChange={setSelectedTeachers}
                                />
                            )}

                        </div>
                        <div className="form-group" style={{ marginTop: 16 }}>
                            <label>Select Session</label>
                            <Select
                                options={sessionOptions}
                                value={editSession}
                                onChange={setEditSession}
                                placeholder="Select session"
                            />
                        </div>
                        <div className="form-group" style={{ marginTop: 16 }}>
                            <label>Tingkatan (MOEIS)</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editTingkatan}
                                onChange={(e) => setEditTingkatan(e.target.value)}
                            />
                        </div>
                        <div className="form-group" style={{ marginTop: 16 }}>
                            <label>MOEIS Class Format</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editClassMoeis}
                                onChange={(e) => setEditClassMoeis(e.target.value)}
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={handleSaveChanges}>
                            Save Changes
                        </Button>
                        <Button color="secondary" onClick={closeEditModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
            <Modal isOpen={isAddModalOpen} toggle={closeAddModal}>
                <ModalHeader toggle={closeAddModal}>
                    Add New Class
                </ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        <label>Class Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={newClassName}
                            onChange={(e) => setNewClassName(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Select Standard/Form</label>
                        <Select
                            options={forms}
                            value={selectedForm}
                            onChange={setSelectedForm}
                        />
                    </div>
                    <div className="form-group">
                        <label>Tingkatan (MOEIS)</label>
                        <input
                            type="text"
                            className="form-control"
                            value={newTingkatan}
                            onChange={(e) => setNewTingkatan(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>MOEIS Class Format</label>
                        <input
                            type="text"
                            className="form-control"
                            value={newClassMoeis}
                            onChange={(e) => setNewClassMoeis(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Select Session</label>
                        <Select
                            options={sessionOptions}
                            value={selectedSession}
                            onChange={setSelectedSession}
                            placeholder="Select session"
                        />
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button color="btn btn-dark" onClick={handleAddClass}>
                        Add Class
                    </Button>
                    <Button color="btn btn-primary" onClick={closeAddModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal}>
                <ModalHeader toggle={closeDeleteModal}>
                    Confirm Delete
                </ModalHeader>
                <ModalBody>
                    Are you sure you want to delete the class: <strong>{selectedClass?.class_name}</strong>?
                </ModalBody>
                <ModalFooter>
                    <Button color="btn btn-dark" onClick={handleDeleteClass}>
                        Yes, Delete
                    </Button>
                    <Button color="btn btn-primary" onClick={closeDeleteModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default ClassesPage;
